export default{px:"S",py:"S",border:"S",borderRadius:"NONE"};
